import React, { useEffect, useState } from "react";
import { CommonModal } from "../../../AbstractElements";
import { Row, Col, Form, FormGroup, Label } from "reactstrap";
import Select from "react-select";
import { useForm, useController } from "react-hook-form";
import { getCarTypes, showAlert } from "../../../Services/Shared.service";
import { createDriverAdhoc } from "../../../Services/DispatchDashboard.service";
import CustomSelect from "../../../CommonElements/CustomSelect";

const CreateDriver = ({
  Large,
  title,
  LargeModaltoggle,
  aggregatorList,
  driverTypeList,
  cityDataList,
  setShowApiLoader,
}) => {
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    reset
  } = useForm();
  const aggregatorField = useController({
    name: "aggregatorDropdown",
    control,
    rules: {
      required: {
        value: true,
        message: "Aggregator is Required",
      },
    },
  }).field;

  const [carTypeData, setCarTypeData] = useState([]);

  const cityField = useController({
    name: "city",
    control,
    rules: {
      required: {
        value: true,
        message: "City is Required",
      },
    },
  }).field;

  const carTypeField = useController({
    name: "carTypeDropdown",
    control,
    rules: {
      required: {
        value: true,
        message: "Car type is Required",
      },
    },
  }).field;

  const driverTypeField = useController({
    name: "driverTypeDropdown",
    control,
    rules: {
      required: {
        value: true,
        message: "Driver Type is Required",
      },
    },
  }).field;

  const driverMobileField = useController({
    name: "driverMobile",
    control,
    rules: {
      required: {
        value: true,
        message: "Driver Mobile is Required",
      },
      maxLength: 10
    },
  }).field;

  const cityData = cityDataList ? cityDataList : [];

  useEffect(() => {
    const serviceCityId = cityField.value?.id;
    if (!serviceCityId) {
      setCarTypeData([]);
      return;
    }
    let obj = {
      serviceCityId,
    };
    getCarTypes(obj)
      .then((result) => {
        const data = result.data.map((element) => {
          return {
            label: element.name,
            value: element,
          };
        });
        setCarTypeData(data);
      })
      .catch((err) => {
        showAlert("error", "Unable to fetch Car details for selected City");
      });
  }, [cityField.value]);

  const onFormSubmit = (formValues) => {
    console.log("form values", formValues);
    const body = {
      fullName: formValues.driverName,
      mobile: formValues.driverMobile,
      driverTypeId: formValues.driverTypeDropdown?.id,
      vendor: formValues.vendor || "NA",
      aggregatorId: formValues.aggregatorDropdown?.id,
      serviceCityId: formValues.city?.id,
      carType: formValues.carTypeDropdown?.name,
      carTypeId: formValues.carTypeDropdown?.id,
      gender: "M",
      addressLine: "NA",
      city: formValues.city?.name,
      licenseNo: "NA",
      mainCabNo: formValues.cabNo,
      isAvailable: true,
      panCardNo: formValues.panCard.length > 0 ? formValues.panCard : null,
      dob: null,
      licenseExpiry: null,
      badgeExpiry: null,
      displayCardNoExpiry: null,
      policeVerificationExpiry: null,
      policeVerificationDate: null,
      isDriverAdhoc: true
    };
    console.log(body, "bodybodybodybodybody");
    setShowApiLoader(true);
    createDriverAdhoc(body)
      .then((result) => {
        setShowApiLoader(false);
        showAlert("success", "Created Driver Successfully");
        reset()
        LargeModaltoggle();
      })
      .catch((err) => {
        setShowApiLoader(false);
        showAlert("error", err.response?.data?.message ? err.response.data.message : "Something went wrong");
      });
  };
  const handleAggregatorSelect = (data) => {
    aggregatorField.onChange(data.value);
  };

  const handleCitySelectChange = (data) => {
    cityField.onChange(data.value);
  };

  const handleCarTypeSelectChange = (data) => {
    carTypeField.onChange(data.value);
  };

  const handleDriverTypeSelectChange = (data) => {
    driverTypeField.onChange(data.value);
  };

  return (
    <CommonModal
      isOpen={Large}
      title={title}
      toggler={()=>{
        reset()
        LargeModaltoggle()

      }}
      size="xl"
    >
      <Form onSubmit={handleSubmit(onFormSubmit)} className="create-adhoc-driver">
        <Row>
          <FormGroup className="col-lg-4">
            <Label className="col-lg-12 col-form-label">Aggregator</Label>
            <Col className="col-lg-12">
              <CustomSelect
                className="driver-type-select"
                classNamePrefix="driver-type-select-options"
                isClearable={false}
                isSearchable={false}
                defaultValue={aggregatorList.find((element) => {
                  return element.value === aggregatorField?.value;
                })}
                onChange={handleAggregatorSelect}
                placeholder="Select Aggregator"
                options={aggregatorList}
              />
              <span style={{ color: "red" }}>
                {errors?.aggregatorDropdown?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-4">
            <Label className="col-lg-12 col-form-label">City</Label>
            <Col lg="12">
              <div className="city-select">
                <CustomSelect
                  className="service-select"
                  classNamePrefix="select"
                  isClearable={false}
                  isSearchable={false}
                  value={cityData.find((element) => {
                    console.log(
                      cityField?.value?.id,
                      element?.value?.id,
                      "element?.value?.idelement?.value?.id"
                    );
                    return element?.value?.id === cityField?.value?.id;
                  })}
                  // defaultValue={cityData.find((element) => {
                  //   console.log(cityField?.value?.id,element?.value?.id,'element?.value?.idelement?.value?.id');
                  //   return element?.value?.id === cityField?.value?.id;
                  // })}
                  onChange={handleCitySelectChange}
                  placeholder="Select City"
                  options={cityData}
                />
              </div>
              <span style={{ color: "red" }}>{errors?.city?.message}</span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-4">
            <Label className="col-lg-12 col-form-label">Cab No</Label>
            <Col lg="12">
              <input
                className="form-control"
                {...register("cabNo", {
                  required: {
                    value: true,
                    message: "Cab Number is required",
                  },
                  onChange: (e) => {
                    setValue("cabNo", e.target.value.trimStart())
                  }
                })}
                type="text"
              />
              <span style={{ color: "red" }}>{errors?.cabNo?.message}</span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-4">
            <Label className="col-lg-12 col-form-label">Cab Type</Label>
            <Col lg="12">
              <div className="city-select">
                <CustomSelect
                  className="service-select"
                  classNamePrefix="select"
                  isClearable={false}
                  isSearchable={false}
                  value={carTypeData.find((element) => {
                    return element?.value?.id === carTypeField?.value?.id;
                  })}
                  isDisabled={cityField?.value?.id ? false : true}
                  onChange={handleCarTypeSelectChange}
                  placeholder={
                    cityField?.value?.id
                      ? "Select Car Type"
                      : "Select city to select car type"
                  }
                  options={carTypeData}
                />
              </div>
              <span style={{ color: "red" }}>
                {errors?.carTypeDropdown?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-4">
            <Label className="col-lg-12 col-form-label">Driver Name</Label>
            <Col lg="12">
              <input
                className="form-control"
                {...register("driverName", {
                  required: {
                    value: true,
                    message: "Driver Name is required",
                  },
                  onChange: (e) => {
                    setValue("driverName", e.target.value.trimStart())
                  }
                })}
                type="text"
              />
              <span style={{ color: "red" }}>
                {errors?.driverName?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-4">
            <Label className="col-lg-12 col-form-label">Mobile</Label>
            <Col lg="12">
              <input
                type="text"
                className="form-control"
                placeholder="Driver Mobile"
                maxLength={10}
                value={driverMobileField.value}
                pattern="[0-9]+"
                onChange={(e) => {
                  driverMobileField.onChange(e.target.value.replace(/[^0-9]/g, ''))
                  console.log("value", e.target.value)
                }}
              />
              <span style={{ color: "red" }}>
                {errors?.driverMobile?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-4">
            <Label className="col-lg-12 col-form-label">Driver Type</Label>
            <Col className="col-lg-12">
              <CustomSelect
                className="driver-type-select"
                classNamePrefix="driver-type-select-options"
                isClearable={false}
                isSearchable={false}
                defaultValue={driverTypeList.find((element) => {
                  return element.value === driverTypeField?.value;
                })}
                onChange={handleDriverTypeSelectChange}
                placeholder="Select Driver Type"
                options={driverTypeList}
              />
            </Col>
            <span style={{ color: "red" }}>
              {errors?.driverTypeDropdown?.message}
            </span>
          </FormGroup>
          <FormGroup className="col-lg-4">
            <Label className="col-lg-12 col-form-label">Pan Card</Label>
            <Col lg="12">
              <input
                className="form-control"
                {...register("panCard")}
                type="text"
              />
              <span style={{ color: "red" }}>{errors?.panCard?.message}</span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-4">
            <Label className="col-lg-12 col-form-label">Vendor</Label>
            <Col lg="12">
              <input
                className="form-control"
                {...register("vendor")}
                type="text"
              />
              <span style={{ color: "red" }}>{errors?.vendor?.message}</span>
            </Col>
          </FormGroup>
        </Row>
        <Row className="submit-driver">
          <button className="btn btn-primary" type="submit">
            Create
          </button>
        </Row>
      </Form>
    </CommonModal>
  );
};

export default CreateDriver;
